import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_ASSORTGROUP, GET_COLORS, GET_SHAPEGROUP } from "../../../api/apiRoutes";
import { AssortGroup } from "../../../models/AssortGroup";

export default function useTickets() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [assortGroup, setAssortGroup] = useState<AssortGroup[]>([]);
  const [colorGroup, setColorGroup] = useState<AssortGroup[]>([]);
  const [shapeGroup, setShapeGroup] = useState<AssortGroup[]>([]);


      const requestGetAssortGroups = async () => {
        const { result, isError } = await get(GET_ASSORTGROUP(facilityIds));
        if (!isError) {
          setAssortGroup(result);
        }
      };
      const requestGetColorGroups = async () => {
        const { result, isError } = await get(GET_COLORS(facilityIds));
        if (!isError) {
          setColorGroup(result);
        }
      };

      const requestGetShapeGroup = async () => {
        const { result, isError } = await get(GET_SHAPEGROUP(facilityIds));
        if (!isError) {
          setShapeGroup(result);
        }
      };

  return {
    requestGetAssortGroups,
    requestGetColorGroups,
    requestGetShapeGroup,
    assortGroup,
    colorGroup,
    shapeGroup,
  };
}
